import { render, staticRenderFns } from "./OwnerWizard.vue?vue&type=template&id=4b3562ca&scoped=true&"
import script from "./OwnerWizard.vue?vue&type=script&lang=js&"
export * from "./OwnerWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3562ca",
  null
  
)

export default component.exports